var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 145,
    viewBox: "0 0 161 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8309 26.8468L38.8899 6.00166C41.6531 1.22532 47.7668 -0.416873 52.5513 2.33207L86.5385 21.8593M8.49367 59.5022L2.45666 69.4281C-0.458025 74.2204 1.14185 80.4652 6.00166 83.2654L12.7028 87.1266M73.4975 122.774L107.713 141.995C112.491 144.68 118.546 143.022 121.29 138.278L133.166 117.75M152.947 83.5295L158.067 74.6931C160.837 69.9121 159.201 63.7974 154.413 61.0387L147.726 57.1858",
    stroke: "#A0A0A0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2983 26.4453H138.93C143.901 26.4454 147.93 30.4748 147.93 35.4453V108.752C147.93 113.722 143.901 117.752 138.93 117.752H21.2983C16.3279 117.752 12.2986 113.722 12.2983 108.752V35.4453C12.2983 30.4748 16.3278 26.4453 21.2983 26.4453Z",
    stroke: "#A0A0A0",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8633 26.8467V45.2859M63.8633 117.149V75.3201",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8638 51.6738C68.1884 51.6741 71.6907 55.1723 71.6909 59.4834C71.6909 63.7947 68.1886 67.2937 63.8638 67.2939C59.5388 67.2939 56.0356 63.7949 56.0356 59.4834C56.0359 55.1721 59.5389 51.6738 63.8638 51.6738Z",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9033 59.4839H24.5439",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.99 59.4839H147.526",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3116 45.8938C45.8066 41.2628 55.1693 48.3375 58.4463 53.0762C53.9522 57.7215 55.37 63.2211 57.2425 65.0899C45.606 53.4767 35.9089 60.6181 32.5651 65.6906C30.1576 63.0876 27.4082 51.2927 37.3116 45.8938Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9546 53.8776C55.6776 49.1389 46.7563 40.9429 37.2866 46.0688C25.4495 52.4761 31.4684 67.2929 33.4747 69.4954C35.481 71.6979 45.3118 82.9107 58.9546 65.6911",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2402 67.4271C53.3614 61.487 43.1049 53.3972 31.8697 66.6923",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6131 86.6489C48.6131 81.443 52.3665 81.7492 55.8358 78.0391C59.7676 73.8343 58.5186 67.8177 64.1709 67.293",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6193 86.6489C79.6193 81.443 75.8659 81.7492 72.3966 78.0391C68.4648 73.8343 69.7138 67.8177 64.0615 67.293",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3212 45.8938C81.8262 41.2628 72.4635 48.3375 69.1865 53.0762C73.6806 57.7215 72.2628 63.2211 70.3903 65.0899C82.0268 53.4767 91.7239 60.6181 95.0677 65.6906C97.4752 63.0876 100.225 51.2927 90.3212 45.8938Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6782 53.8776C71.9552 49.1389 80.8765 40.9429 90.3462 46.0688C102.183 52.4761 96.1644 67.2929 94.1581 69.4954C92.1518 71.6979 82.321 82.9107 68.6782 65.6911",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2812 67.6273C74.1601 61.6872 84.5283 53.3972 95.7635 66.6923",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.9462e0c3714ac10c83b1b8ddb3a32ecd.svg";
export { ForwardRef as ReactComponent };